"use client";

import { faPaperPlane } from "@fortawesome/pro-solid-svg-icons";
import { SubmitButton } from "@tosize/ui";
import { useFormContext } from "react-hook-form";
import { TicketType } from "../types";

interface SubmitProps {
	btnLabel: string;
}

export function Submit({ btnLabel }: SubmitProps) {
	const { watch } = useFormContext();

	const category: unknown = watch("type");

	if (!category || category === TicketType.CHANGE) {
		return null;
	}

	return (
		<SubmitButton starticon={faPaperPlane} className="mt-4 w-full" color="primary" size="large">
			{btnLabel}
		</SubmitButton>
	);
}
